import { defineMessages } from 'react-intl'

const scope = `procurify.expense.components.ExpenseStatusLabel`

export default defineMessages({
  statusAriaLabel: {
    id: `${scope}.statusAriaLabel`,
    defaultMessage: 'Expense status',
  },
  statusTextPending: {
    id: `${scope}.statusTextPending`,
    defaultMessage: 'Pending approval',
  },
  statusTextApproved: {
    id: `${scope}.statusTextApproved`,
    defaultMessage: 'Approved',
  },
  statusTextDenied: {
    id: `${scope}.statusTextDenied`,
    defaultMessage: 'Denied',
  },
  statusTextDraft: {
    id: `${scope}.statusTextDraft`,
    defaultMessage: 'Draft',
  },
  statusTextUnknown: {
    id: `${scope}.statusTextUnknown`,
    defaultMessage: 'Unknown',
  },
})
